forestControllers.controller('sbKvartaliController', function($scope, sbKvartalis) {

    /**
     *
     * There is also variable called $scope.kvartalis that comes with dropDownData
     */

    $scope.sbKvartalis = sbKvartalis;

    $scope.setKvartali = function(num){

        /**
         * If kvartali is already same $watch handler defined in parent controller will not trigger
         * and view will not update so we run handler manually in this case.
         */
        if($scope.barati.locations.kvartali == num){
            $scope.updateState();
        } else {

            $scope.barati.locations.kvartali = num;

            /**
             * We need to reset literi whenever kvartali is changed
             *
             */
            $scope.barati.locations.literi = null;
        }

    };

    $scope.newKvartali = function(){
        var num = $scope.sbKvartalis.length > 0 ? $scope.sbKvartalis[$scope.sbKvartalis.length - 1].kvartali + 1 : 1;

        $scope.setKvartali(num);
    };

});